import { gql } from "@apollo/client";

export const SAVE_QUOTATION = gql`
  mutation saveCascoQuotation($input: SaveInsuranceQuotationInput!) {
    saveCascoQuotation(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const SELECT_QUOTATION = gql`
  mutation selectQuotation($input: SelectQuotationInput!) {
    selectQuotation(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const UPDATE_QUOTATION_LOCK = gql`
  mutation updateQuotationLock($input: UpdateQuotationLockInput!) {
    updateQuotationLock(input: $input) {
      commandId
      correlationId
    }
  }
`;
